import { createAsyncThunk } from "@reduxjs/toolkit";
import { fetchReorderProducts as fetchReorderProductsService } from "./reorder.service";
import { ReorderResponse, GetReorderRequest } from "./reorder.types";
import { handleApiError } from "@/app/utils/handleApiError";

export const getReorderProducts = createAsyncThunk<
  ReorderResponse,
  GetReorderRequest | undefined,
  { rejectValue: string }
>("reorder/getReorderProducts", async (params, { rejectWithValue }) => {
  try {
    const response = await fetchReorderProductsService(params);
    return response;
  } catch (error) {
    return rejectWithValue(handleApiError(error));
  }
});